import { Component, OnInit } from '@angular/core';
import { Manufacture } from '../manufacture';
import { ManufactureService } from '../manufacture.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-manufacture',
  templateUrl: './manufacture.component.html',
  styleUrls: ['./manufacture.component.css'],
  providers: [ManufactureService]
})
export class ManufactureComponent implements OnInit {

	manufacturers: Manufacture[];

  constructor(private manufactureService: ManufactureService, private router: Router) { }

  ngOnInit() {
        this.manufactureService.getManufacture().subscribe(response=> {this.manufacturers=response['data'];});
    }

 clicked():void {
   		this.router.navigate(['dashboard/manufacture-crud']);
  }  

 clickedId(id: any){
   		 console.log("ha");
    	 this.router.navigate(['dashboard/manufacture-crud/',id]);
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/manufacturers/manufacture/manufacture.component.ts